import {
	DATE_CF_TYPE,
	DUE_DATE_TYPE,
	START_DATE_TYPE,
} from '@atlassian/jira-platform-field-config';
import type { DataTransformFn } from '../../../bulk-edit-transform/types';
import type { JiraDateField as DateField } from '../fragment';
import type { DateFormData } from './types';

export const transformDateFieldForOptimisticUpdates: DataTransformFn<DateField, DateFormData> = (
	existingField: DateField,
	fieldData: DateFormData,
): DateField => ({
	...existingField,
	date: fieldData ?? null,
});

export const dateOptimisticUpdatesHandler: {
	[key: string]: DataTransformFn<DateField, DateFormData>;
} = {
	[DATE_CF_TYPE]: transformDateFieldForOptimisticUpdates,
	[DUE_DATE_TYPE]: transformDateFieldForOptimisticUpdates,
	[START_DATE_TYPE]: transformDateFieldForOptimisticUpdates,
};
